import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FiEye, FiInfo } from "react-icons/fi";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { getTrainingManagementStatusClass, TM_STATUS } from "../CONSTANTS";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { isUserVTO } from "../../IncidentManagement/Helper";
import { TRAINING_STATUS, TRAINEE_TYPE, trainingStatusFilterFields } from "../CONSTANTS";
import { getMyApprovalHistory } from "app/_services/ehs/ehsTrainingServices";
import TrainingBatchTab from "../Assign/Component/TrainingBatchTab";
import TrainingBatchHistoryTab from "../Assign/Component/TrainingBatchHistoryTab";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import TrainingStatusFilters from "../Assign/Component/TrainingStatusFilters";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const MyApprovalHistory = ({
  match: {
    params: { siteId },
  },
}) => {
  const [tab, setTab] = useState(1);
  const [trainings, setTrainings] = useState({
    minesManager: [],
    safetyOfficer: [],
    vocationalTrainingOfficer: [],
  });
  const [tableVFLList, setTableVFLList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showFilterBtn, setShowFilterBtn] = useState(true);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);

  const onReset = () =>
    setFilterForm({
      batchName: "",
      centerName: "",
      centerCode: "",
      traineeDesignation: "",
    });

  useEffect(() => {
    setShowFilterBtn(true);
  }, [tab]);

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "traineeTypeView") {
        prev.traineeId = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const downloadPdf = async (id) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-training-certificate/" +
        id,
      `training-certificate-${new Date().toISOString()}.pdf`
    );
  };
  const [sort, setSort] = useState({ order: "asc", dataField: "" });

  const tableContainerRef = useRef(null);

  const onTableChange = (actionType, { sortField: dataField, sortOrder: order }) => {
    if (actionType !== "sort") return;

    setSort({ dataField, order });
    setTableVFLList((prev) => {
      const newRows = [...prev].sort((a, b) => {
        if (order === "asc") return a[dataField] > b[dataField] ? -1 : 1;
        else return a[dataField] < b[dataField] ? -1 : 1;
      });

      return newRows;
    });
  };

  const updateTab = (n) => {
    setTableVFLList([]);
    setTab(n);
  };

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (idx, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "traineeDesignation",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "trainingTypeView",
        text: "Training Type",
        sort: true,
      },
      {
        dataField: "trainingCategoryName",
        text: "Skill Category",
        sort: true,
      },
      // {
      //   dataField: "trainingSubCategoryName",
      //   text: "Training Sub-Category",
      //   sort: true,
      // },

      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
        formatter: (startDate) => {
          return DDMMYYYYFormat(startDate);
        },
      },
      {
        dataField: "batchName",
        text: "Batch ID",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() ? (
                <CustomTooltip tooltip={"Certificate"}>
                  {/* <a href={"/health-safety-and-environment/training-management/certificate/" + row?.id} target="_blank" rel="noopener noreferrer" className="icons text-cyanBlue">
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </a> */}
                  <span
                    onClick={() => downloadPdf(row?.id)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              ) : (
                "In Progress"
              )}
            </div>
          );
        },
      },
      {
        dataField: "ID",
        text: "Action",
        sort: true,
        formatter: (cell, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={`${
                    siteId ? "/sites/" + siteId : ""
                  }/health-safety-and-environment/training-management/view/${row.id}`}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ];

    return column;
  }, [siteId]);

  useEffect(() => {
    // getMyApprovalHistory(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;

    //   setTrainings(response.data);
    //   if (!response.data.vocationalTrainingOfficer?.length)
    //     setTab(response.data.safetyOfficer?.length ? 2 : 3);
    // });
    const fetchData = async () => {
      try {
        const response = await getMyApprovalHistory(
          siteId ? `filter[siteId]=${siteId}` : ""
        );

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }

        setTrainings(response.data);
        if (!response.data.vocationalTrainingOfficer?.length)
          setTab(response.data.safetyOfficer?.length ? 2 : 3);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };

    fetchData();
  }, [siteId]);

  // useEffect(() => {
  //   setTableVFLList(
  //     trainings[tab === 1 ? "vocationalTrainingOfficer" : tab === 2 ? "safetyOfficer" : "minesManager"]
  //       .filter((d) => (filter.traineeType === "all" || d.traineeType === filter.traineeType) && (!filter.status || d.trainingStatus === filter.status))
  //       .map((row, index) => ({ ...row, sid: index + 1 }))
  //   );
  // }, [filter.traineeType, trainings, tab, filter.status]);

  useEffect(() => {
    setTableVFLList(
      trainings[
        tab === 1
          ? "vocationalTrainingOfficer"
          : tab === 2
          ? "safetyOfficer"
          : "minesManager"
      ]?.filter?.((data) => {
        let flag = true;
        if (filterForm?.traineeTypeView === "All") flag = true;

        if (flag) {
          for (const key in filterForm) {
            if (
              (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
              !filterForm[key]
            )
              continue;
            if (
              key !== "traineeDesignation" &&
              key !== "batchName" &&
              data[key] !== filterForm[key]
            )
              return (flag = false);
            else if (
              (key === "traineeDesignation" || key === "batchName") &&
              !data[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
            )
              return (flag = false);
          }

          return (flag = true);
        }
        // if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, tab, trainings]);

  const tableToolbarBeforeView = () =>
    tab !== 1 &&
    showFilter && (
      <TrainingStatusFilters
        fields={trainingStatusFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "My Approval History" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          {(trainings.minesManager.length > 0 ||
            trainings.safetyOfficer.length > 0 ||
            trainings.vocationalTrainingOfficer.length > 0) && (
            <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
              {trainings.vocationalTrainingOfficer.length > 0 && (
                <a
                  className={`${tab === 1 ? "active" : ""}`}
                  href
                  onClick={() => updateTab(1)}
                >
                  Vocational Training Officer
                </a>
              )}
              {trainings.safetyOfficer.length > 0 && (
                <a
                  className={`${tab === 2 ? "active" : ""}`}
                  href
                  onClick={() => updateTab(2)}
                >
                  Safety Officer
                </a>
              )}
              {trainings.minesManager.length > 0 && (
                <a
                  className={`${tab === 3 ? "active" : ""}`}
                  href
                  onClick={() => updateTab(3)}
                >
                  Mines Manager
                </a>
              )}
            </div>
          )}
        </div>
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">My Approval History</h3>
              {showFilterBtn && <FilterBtn setShowFilter={setShowFilter} />}
              <BackBtn url="/health-safety-and-environment/training-management" />
            </div>
            {tab === 1 ? (
              <TrainingBatchHistoryTab
                batchesData={tableVFLList}
                showFilter={showFilter}
                setShowFilterBtn={setShowFilterBtn}
              />
            ) : (
              <>
                {!loading ? (
                  <SearchBootstrapTable
                    searchKey={"myApprovalHistoryDesktopSearch"}
                    data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                    columns={sortableColumn}
                    onTableChange={onTableChange}
                    sort={sort}
                    remote={{
                      sort: true,
                    }}
                    tableBeforeSearch={tableToolbarBeforeView}
                    tableKey="myApprovalHistory"
                  />
                ) : (
                  <NetZeroLoader />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyApprovalHistory;
